import { render, staticRenderFns } from "./Partners.vue?vue&type=template&id=32828f5b&scoped=true"
import script from "./Partners.vue?vue&type=script&lang=js"
export * from "./Partners.vue?vue&type=script&lang=js"
import style0 from "./Partners.vue?vue&type=style&index=0&id=32828f5b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32828f5b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32828f5b')) {
      api.createRecord('32828f5b', component.options)
    } else {
      api.reload('32828f5b', component.options)
    }
    module.hot.accept("./Partners.vue?vue&type=template&id=32828f5b&scoped=true", function () {
      api.rerender('32828f5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Partners.vue"
export default component.exports